import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

import {EventRegistrationCode} from 'shared/classes/event-registration-code';
import {Company} from 'shared/models/target-groups/company';
import { TargetGroup } from 'shared/models/target-groups/target-group';

@Injectable()
export class EventRegistrationRepository {

  constructor(private http: Http) { }

  public getAllCodes(): Observable<Array<EventRegistrationCode>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.eventRegistration.codes}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllCompanies(): Observable<Array<Company>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.targetGroups.companies}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public createCode(code: EventRegistrationCode): Observable<EventRegistrationCode> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(this.prepareCodeForBackend(code));

    return this.http.post(`${environment.eventRegistration.codes}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public invalidateCode(code: string): Observable<void> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});

    return this.http.put(`${environment.eventRegistration.codes}/${code}/invalidate`, null, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  private prepareCodeForBackend(code: EventRegistrationCode): any { // tslint:disable-line:no-any
    const newCode: any = { // tslint:disable-line:no-any
      code: code.code,
      companyId: code.company._id,
      valid: code.valid,
      groups: code.groups,
      categories: code.categories,
    };

    return newCode;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/event-registration/repositories/event-registration.repository.ts